import { createContext } from 'react';

export const CarouselMetaContext = createContext({ currentSlide: 0 });
CarouselMetaContext.displayName = 'CarouselMetaContext';
